import React, { FC } from 'react';
import { Button } from 'hui';
import styled from 'styled-components';

const RestartWrapper = styled.div`
  margin-top: 1rem;
`;

interface RestartProcessAreaProps {
  restartProcess(): void;
}

const RestartProcessArea: FC<RestartProcessAreaProps> = ({ restartProcess }) => (
  <RestartWrapper>
    <Button color="primary" onClick={restartProcess}>
      Restart process
    </Button>
  </RestartWrapper>
);

export default RestartProcessArea;
